import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import { PaginationBack, PaginationNext } from './icons'


const PaginatorStyleSheet =
    {
        root: {
            width: '100%',
            fontSize: 12,
            color: "rgba(0,0,0,0.5)",
            height: 60,
        },
        button: {
            cursor: 'pointer',
            padding: 0,
            margin: 0,
            border: 'None',
            height: 13,
            background: 'transparent',
            '&:focus': {
                outline: 'None',
            },
        },

        buttonDisabled: {
            extend: 'button',
            cursor: 'not-allowed',
        },
        selectRoot: {
            fontSize: '12px'
        },
        selectMenu: {
            fontSize: '12px',
            paddingTop: '6px',
            '&:focus': {
                background: 'none'
            }
        }
    };

const PaginatorComponent = ({ classes, text, itemsTotal = 0, pageNumber, itemsPerPage = 10, onNextClick, onPreviousClick, countSelector = false, changeitemsPerPage }) => {
    const isFirstPage = pageNumber === 1;
    const isLastPage = pageNumber * itemsPerPage >= itemsTotal;
    const startItem = (pageNumber - 1) * itemsPerPage + 1;
    const endItem = Math.min(pageNumber * itemsPerPage, itemsTotal);
    return (
        <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
            className={classes.root}
            spacing={3}
        >
            <Grid item>
                {text}
            </Grid>
            {countSelector &&
                <Grid item>
                    <Select
                        value={itemsPerPage}
                        onChange={changeitemsPerPage}
                        classes={{
                            root: classes.selectRoot,
                            selectMenu: classes.selectMenu,
                        }}
                        input={<Input disableUnderline={true} />}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </Grid>
            }
            <Grid item>
                {startItem}-{endItem} of {itemsTotal}
            </Grid>
            <Grid item>
                <button disabled={isFirstPage} className={isFirstPage ? classes.buttonDisabled : classes.button}
                    onClick={onPreviousClick}
                    aria-label="Paginator Back"
                >
                    <PaginationBack disabled={isFirstPage} />
                </button>
            </Grid>
            <Grid item>
                <button disabled={isLastPage} className={isLastPage ? classes.buttonDisabled : classes.button}
                    onClick={onNextClick}                    
                    aria-label="Paginator Forward"
                >
                    <PaginationNext disabled={isLastPage} />
                </button>
            </Grid>
        </Grid>
    );
};
export default withStyles(PaginatorStyleSheet, { name: 'PaginatorStyleSheet' })(PaginatorComponent);

PaginatorComponent.propTypes = {
    text: PropTypes.string,
    itemsTotal: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    onNextClick: PropTypes.func.isRequired,
    onPreviousClick: PropTypes.func.isRequired
};

